import { render, staticRenderFns } from "./LeadRejectDialog.vue?vue&type=template&id=2b0437b0"
import script from "./LeadRejectDialog.vue?vue&type=script&lang=ts"
export * from "./LeadRejectDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports